export default __webpack_public_path__ + "static/media/AI Concierge.de41b2f0.svg";